var GridView, Thumbnail, getBucket, getDateRender, m, monthNames;

m = require('mithril');

Thumbnail = require('./Thumbnail');

GridView = require('./GridView');

getBucket = function(photo, bucketType) {
  var date;
  if (bucketType == null) {
    bucketType = 'day';
  }
  date = new Date(photo.timestamp.epoch);
  if (bucketType === 'month') {
    date.setDate(1);
  }
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date;
};

monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

getDateRender = function(date, bucketType) {
  if (bucketType == null) {
    bucketType = 'day';
  }
  switch (bucketType) {
    case 'month':
      return monthNames[date.getMonth()] + " " + (date.getFullYear());
    default:
      return (date.getFullYear()) + "-" + ('0' + (date.getMonth() + 1)).slice(-2) + "-" + ('0' + date.getDate()).slice(-2);
  }
};

module.exports = {
  controller: function(args) {
    var bucket, ctrl, i, len, ref;
    ctrl = this;
    ctrl.buckets = args.photos.reduce((function(groups, photo) {
      var date, g, group;
      date = getBucket(photo, args.bucketType);
      group = ((function() {
        var i, len, results;
        results = [];
        for (i = 0, len = groups.length; i < len; i++) {
          g = groups[i];
          if (g.date.getTime() === date.getTime()) {
            results.push(g);
          }
        }
        return results;
      })())[0];
      if (!(group != null)) {
        group = {
          date: date,
          photos: []
        };
        groups.push(group);
      }
      group.photos.push(photo);
      return groups;
    }), []);
    ctrl.buckets.sort(function(a, b) {
      if (a.date < b.date) {
        return -1;
      }
      if (a.date > b.date) {
        return +1;
      }
      return 0;
    });
    ref = ctrl.buckets;
    for (i = 0, len = ref.length; i < len; i++) {
      bucket = ref[i];
      bucket.photos.sort(function(a, b) {
        if (a.timestamp.epoch < b.timestamp.epoch) {
          return -1;
        }
        if (a.timestamp.epoch > b.timestamp.epoch) {
          return +1;
        }
        return 0;
      });
    }
    return ctrl;
  },
  view: function(ctrl, args) {
    var group;
    return m('.DateView', [
      (function() {
        var i, len, ref, results;
        ref = ctrl.buckets;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          group = ref[i];
          results.push([
            m('.date', getDateRender(group.date, args.bucketType)), m(GridView, {
              leftAlign: true,
              photos: group.photos,
              onPhotoSelect: args.onPhotoSelect
            })
          ]);
        }
        return results;
      })()
    ]);
  }
};

//# sourceMappingURL=data:application/json;base64,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
